import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ClientInputContentGroup } from 'client/models';

@Component({
    selector: 'client-form-page-step',
    templateUrl: './client-form-page-step.component.html',
    styleUrls: ['./client-form-page-step.component.scss'],
    standalone: false
})
export class ClientFormPageStepComponent {

  @Input() formGroupInput!: FormGroup;
  @Input() inputContentGroupList: ClientInputContentGroup[] = [];

}
